import { CButton, CCol, CRow } from '@coreui/react'
import { Icon } from '@iconify/react'

export const RegisterStep6 = ({ DataForm, code, setDataForm, onCancel, onSuccess }) => {

    return (
        <CRow style={{
            fontFamily: 'Arial, sans-serif',
            backgroundColor: '#f6f8fa',
            padding: '20px',
            color: '#333',
            display: 'flex',
            justifyContent: 'center',
        }}>
            <CCol xs="4" className="d-flex justify-content-center align-items-center">
                <Icon icon="fluent-mdl2:processing" width={200} color="#40b549" />
            </CCol>
            <CCol xs="7">

                <div
                    style={{
                        fontFamily: 'Arial, sans-serif',
                        backgroundColor: '#f6f8fa',
                        padding: '20px',
                        color: '#333',
                        display: 'flex',
                        justifyContent: 'center',
                    }}
                >
                    <div
                        style={{
                            maxWidth: '600px',
                            backgroundColor: '#ffffff',
                            padding: '30px',
                            borderRadius: '8px',
                            boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
                        }}
                    >
                        <div
                            style={{
                                borderRadius: '8px',
                                textAlign: 'center',
                                marginBottom: 20

                            }}
                        >
                            <Icon icon="line-md:confirm-circle" width={80} color="blue" />

                            <h3 className="text-primary">Registro Exitoso.</h3>
                        </div>
                        <h2 style={{ color: '#40b549' }}>¡Bienvenido a CoopSys CoreBank!</h2>


                        <p style={{ marginBottom: '15px', lineHeight: '1.6' }}>
                            Hola <strong>{DataForm.representante.nombre}</strong>, muchas gracias por registrar su cooperativa <strong>{DataForm.nombre}</strong> en nuestra plataforma.
                        </p>

                        <p style={{ marginBottom: '15px', lineHeight: '1.6' }}>
                            Estamos creando su <strong>instancia de datos</strong>; su cooperativa estará lista para operar en los próximos minutos. Le notificaremos por correo electrónico tan pronto todo esté disponible.
                        </p>

                        <p style={{ marginBottom: '15px', lineHeight: '1.6' }}>
                            Es posible que uno de nuestros <strong>asesores de ventas o soporte</strong> se comunique con usted dentro de las próximas 24 horas para brindarle asistencia personalizada y asegurar que su experiencia con CoopSys CoreBank sea todo un éxito.
                        </p>

                        <p style={{ marginBottom: '15px', lineHeight: '1.6' }}>
                            ¡Gracias por confiar en nosotros!
                        </p>

                        <p style={{ marginTop: '30px' }}>
                            Atentamente,<br />
                            <strong>Equipo de CoopSys CoreBank</strong>
                        </p>
                    </div>
                </div>



                <div
                    className="row justify-content-center"
                    style={{ flexFlow: "row", paddingTop: 50 }}
                >
                    <CButton
                        type="submit"
                        style={{ background: '', height: 60, padding: 0, margin: 0 }}
                        className="btn-block LoginInput2"
                        onClick={onCancel}
                    >
                        <Icon icon="material-symbols:password-2-rounded" width={25} />  Login
                    </CButton>
                    <CButton
                        type="submit"
                        style={{ height: 60, padding: 0, margin: 0 }}
                        className="btn-block LoginInput2"
                        onClick={() => onSuccess()}
                    >

                        Ir Pagina Principal
                        <Icon icon="iconoir:www" width={25} style={{ marginLeft: 10 }} />
                    </CButton>
                </div>
            </CCol>
        </CRow>


    )
}
